import { array } from "AppReact/schema";

export const selectedCategories = {
  selectedCategories: array("string"),
};
